export default __webpack_public_path__ + "static/media/Right.696d8430.svg";